import { dedupe } from '#lib/util/dedupe';
import type { RetrievalContext } from '#src/types/documents.ts';
import type { SecondarySource, SourceDocument } from '#src/types/sources.ts';

export function mergeSources(sources: SourceDocument[]): SourceDocument[] {
	return sources.reduce((acc, val) => {
		const i = acc.findIndex((c) => c.doc_id === val.doc_id);
		if (i > -1) {
			// Merge chunk_ids, deduplicating
			const mergedIds = [...new Set([...acc[i].chunk_ids, ...val.chunk_ids])];
			acc[i] = { ...acc[i], chunk_ids: mergedIds };
			return acc;
		}
		acc.push(val);
		return acc;
	}, [] as SourceDocument[]);
}

export function mergeRetrievalContext(
	existing: RetrievalContext | undefined,
	incoming: RetrievalContext
): RetrievalContext {
	if (!existing) {
		return incoming;
	}

	const existingDocs = existing.documents ?? [];
	const existingChunks = existing.chunks ?? [];

	return {
		documents: dedupe([...existingDocs, ...incoming.documents], 'id'),
		chunks: dedupe([...existingChunks, ...incoming.chunks], 'id')
	};
}

export function mergeSecondarySources(sources: SecondarySource[]): SecondarySource[] {
	return dedupe(sources, 'id');
}
